<template>
  <div class="supermarket-search-body">
    <div class="search-title">
      <span class="back-btn-img" v-show="!leftrightstatus" @click="goBack"><img :src="backicon" alt=""/></span>
      <span class="search-title-input">
        <form action="/">
          <div class="search-div">
            <div class="search-input-con">
              <div class="left-search-icon">
                <img :src="searchicon" alt="" />
              </div>
              <input
                class="search-input"
                type="search"
                placeholder="请输入店铺名称"
                v-model="searchGoodName"
                ref="searchInput"
                @search="searchInput"
                
                @keypress="searchGoods"
                @focus="leftrightstatus = true"
                @blur="inputblur"
              />
              <!-- @input="searchinput"  v-autofocus-->
              <div class="right-search-icon" v-show="searchGoodName&&leftrightstatus">
                <img
                  :src="detailinputcancelicon"
                  alt=""
                  @click.stop="clearInput"
                />
              </div>
            </div>
          </div>
        </form>
      </span>
      <span class="cancel-btn" v-show="leftrightstatus" @click="goBack"
        >取消</span
      >
    </div>
    <div
      class="search-history"
      v-show="goodsSearchLIst.length > 0&&searchhistoryshow&&!noshopShow"
    >
      <div class="history-one">
        <span class="history-title">历史搜索</span>
        <span class="del-btn" @click="pupshow = true"
          ><img :src="deleteicon" alt=""
        /></span>
      </div>
      <div class="tag-div">
        <span
          class="search-tag"
          v-for="(item, index) in goodsSearchLIst"
          :key="index"
          @click="chooseGoodHistory(item)"
          >{{ item }}</span
        >
      </div>
    </div>
    <div v-show="!searchhistoryshow" class="shop-goods-div">
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :style="vanPullRefreshStyle">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="50"> -->
            <div class="empty-placehoder"></div>
            <div class="list-box" v-for="(item, i) in search_goodsList" :key="i">
            <div class="list-box-warpper">
            <div class="list-box-left">
                <img :src="item.logo" alt="">
            </div>
            <div class="list-box-right">
                <div class="content">
                <div class="left" @click="toStoreInfo(item)">
                    <div class="title">
                    <span class="t-left">{{item.shop_name}}</span>
                    <span class="t-right" v-if="item.distance">{{`${((item.distance)/1000).toFixed(2)}km`}}</span>
                    </div>
                    <div class="addres">{{item.address}}</div>
                </div>
                <div class="right" @click="getMap(item)">
                    <img src="../../assets/shared-hotel/position1.png" alt="">
                </div>
                </div>
                <span class="left-amount">剩余可充值额度：{{item.quota_data && parseFloat(item.quota_data.actual_rechargeable_amount).toFixed(2)}}</span>
                <p><span class="right-amount">未核销额度：{{item.quota_data &&parseFloat(item.quota_data.recharged_amount-item.quota_data.consumed_amount) > 0 ? item.quota_data && parseFloat(item.quota_data.recharged_amount-item.quota_data.consumed_amount).toFixed(2):0.00}}</span></p>
                <div class="discounts" :style="item.isfold?'':'height:20px;overflow: hidden;'"  v-if="item.recharge_promotion.length>0">
                <div class="discount" v-for="(item1, i) in item.recharge_promotion" :key="i">充{{item1.recharge_amount}}送{{item1.present_amount}}</div>
                <!-- <div class="discount" v-for="(item, i) in [1]" :key="i">充1000送1000</div> -->
                <img v-if="item.isshowfold" class="foldimg" :src="item.isfold?foldtop:foldbottom" alt="" @click="item.isfold=!item.isfold"/>
                </div>
            </div>
            </div>
            </div>
        <!-- </van-list>
        </van-pull-refresh> -->
    </div>
    <nocity
      v-show="noshopShow"
      height="110px"
      nofindtext="抱歉，用尽全力也没有搜到饭店"
      width="281px"
    />
    <common-pup
      :pupshow="pupshow"
      :pup_content="pup_content"
      @pupcancel="pupcancel"
      @pupcertain="pupcertain"
      pupcertainText="确定"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import nocity from "./components/nocity";
import commonPup from "./components/common-pup.vue";
export default {
    components: {
        commonPup,
        nocity,
    },
    directives: {
        autofocus: {
        inserted: function (el) {
            el.focus();
        },
        },
    },
    data(){
        return{
            leftrightstatus: false,
            backicon: require("@/assets/shared-hotel/returnBlack.png"),
            searchicon: require("@/assets/shared-hotel/search.png"),
            detailinputcancelicon: require("@/assets/shared-hotel/detail-input-cancel-icon.png"),
            deleteicon: require("@/assets/shared-hotel/delete-icon.png"),
            foldbottom:require("@/assets/shared-hotel/fold_bottom.png"),
            foldtop:require("@/assets/shared-hotel/fold_top.png"),
            searchGoodName: "", //搜索的店铺名称
            search_goodsList: [], //搜索到的商品列表
            goodsSearchLIst: [], //搜索历史列表
            searchhistoryshow: true, //是否显示历史搜索页面
            noshopShow: false, //无搜索结果是否显示
            pupshow: false, //弹窗是否显示,
            pup_content: "确认删除历史搜索？",
            supermarketSearchLocalform:localStorage.getItem("goodsSearchLIsts") == null? {}: JSON.parse(localStorage.getItem("goodsSearchLIsts")),
        }
    },
    created() {
        if (this.supermarketSearchLocalform[this.userInfo.user_id] == undefined) {
            this.supermarketSearchLocalform[this.userInfo.user_id] = [];
        }
        this.goodsSearchLIst =this.supermarketSearchLocalform[this.userInfo.user_id]== undefined? [] : this.supermarketSearchLocalform[this.userInfo.user_id];
    },
    mounted() {
    // this.$refs.searchInput.focus();
    },
    computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
    methods:{
        pupcertain() {
            this.goodsSearchLIst = [];
            this.supermarketSearchLocalform[this.userInfo.user_id] = [];
            localStorage.setItem(
                "goodsSearchLIsts",
                JSON.stringify(this.supermarketSearchLocalform)
            );
            this.pupshow = false;
        },
        pupcancel() {
            this.pupshow = false;
        },
        goBack() {
            this.$router.go(-1);
        },
        //选择历史搜索
        chooseGoodHistory(item) {
            this.searchGoodName = item;
            this.shopSearchGood();
        },
        searchGoods(event) {
            if (event.keyCode == 13) {
                //如果按的是enter键 13是enter
                event.preventDefault(); //禁止默认事件（默认是换行）
                this.$refs.searchInput.blur();
                this.shopSearchGood();
            }
        },
        // 清空输入框事件
        clearInput() {
            if (this.searchGoodName == "") {
                return;
            }
            this.searchGoodName = "";
            this.shopSearchGood();
        },
        setLocalGoodsSeach(name) {
            if (
                Object.keys(this.supermarketSearchLocalform[this.userInfo.user_id])
                .length > 0
            ) {
                this.goodsSearchLIst = this.supermarketSearchLocalform[this.userInfo.user_id]
                ? this.supermarketSearchLocalform[this.userInfo.user_id]
                : [];
            }
            if (!this.goodsSearchLIst.includes(name)) {
                if (this.goodsSearchLIst.length < 5) {
                this.goodsSearchLIst.splice(0, 0, name);
                } else if (this.goodsSearchLIst.length == 5) {
                this.goodsSearchLIst = this.goodsSearchLIst.slice(0, 4);
                this.goodsSearchLIst.splice(0, 0, name);
                }
            }
            this.supermarketSearchLocalform[this.userInfo.user_id] = this.goodsSearchLIst;
            localStorage.setItem(
                "goodsSearchLIsts",
                JSON.stringify(this.supermarketSearchLocalform)
            );
        },
        searchInput(){
            this.shopSearchGood()
        },
        inputblur() {
            setTimeout(() => {
                this.leftrightstatus = false;
            }, 100);
        },
         //搜索店铺
        shopSearchGood() {
            if (this.searchGoodName) {
                this.setLocalGoodsSeach(this.searchGoodName);
                this.$api.get('/offshop/member/canteen/membership-card/canteenSearch',{name:this.searchGoodName,lat:this.$route.query.lat,lng:this.$route.query.long}).then((res)=>{
                    //控制折叠
                    res.list.map((item)=>{
                        let str=0;
                        for(let i=0;i<item.recharge_promotion.length;i++){
                            str+=item.recharge_promotion[i].recharge_amount.toString().length+item.recharge_promotion[i].present_amount.toString().length+2
                        }
                        if(str>=22){
                            item.isshowfold=true;//超出24个字就先显示折叠的图标
                            item.isfold=false;
                        }
                    })
                    this.search_goodsList = res.list;
                    if (this.search_goodsList.length > 0) {
                        this.searchhistoryshow = false;
                        this.noshopShow = false;
                    } else {
                        this.searchhistoryshow = true;
                        this.noshopShow = true;
                    }
                })
            } else {
                this.search_goodsList = [];
                this.noshopShow = false;
                this.searchhistoryshow = true;
            }
        },
        toStoreInfo(item) {
            this.$router.push({
                path: "/sharedHotel/storeDetail",
                query: {
                    id: item.id,
                    lng: item.longitude,
                    lat: item.latitude,
                },
            });
        },
        getMap(item) {
            let param = {
                lon: item.longitude,
                lat: item.latitude,
                address:item.address,
            }
            this.params(JSON.stringify(param),JSON.stringify(param),'getMap')
        },
    }
}
</script>

<style lang="less" scoped>
.supermarket-search-body {
//   min-height: 100%;
  height: 100vh;
  overflow: hidden;
}
.search-div {
  padding: 10px 12px;

  .search-input-con {
    flex: 1;
    padding-left: 12px;
    background-color: #f7f8fa;
    padding: 5px 8px 5px 0;
    position: relative;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    border-radius: 999px;
  }

  .search-input {
      -webkit-appearance: none;//input去掉自带的内阴影
      padding-left: 5px;
      box-sizing: border-box;
    &::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #c8c9cc;
    }
    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
    &::-ms-clear,
    &::-ms-reveal {
      display: none;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #c8c9cc;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #c8c9cc;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #c8c9cc;
    }
  }

  .left-search-icon {
    object-fit: contain;
    display: inline-block;
    padding: 0 5px 0 12px;
    height: 24px;
    line-height: 24px;
    overflow: hidden;

    img {
      object-fit: contain;
      margin-top: 4px;
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
  }

  .right-search-icon {
    object-fit: contain;
    display: inline-block;
    padding: 0 5px 0 12px;
    height: 24px;
    line-height: 24px;
    overflow: hidden;

    img {
      object-fit: contain;
      margin-top: 4px;
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
  }
}

.search-input {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #323233;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  border: 0;
  resize: none;
}

.van-search__action {
  width: 32px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #f9591b;
  line-height: 22px;
  color: #f9591b !important;
}

.search-title {
  padding-top: 44px;

  .search-title-input {
    display: inline-block;
    width: calc(100% - 50px);
  }

  .cancel-btn {
    display: inline-block;
    width: 40px;
    height: 54px;
    font-size: 16px;
    font-weight: 400;
    color: #f9591b;
    line-height: 54px;
    position: absolute;
    right: 12px;
  }
}

.history-one {
  padding: 12px;

  .history-title {
    width: 60px;
    height: 21px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
  }

  .del-btn {
    float: right;

    img {
      height: 18px;
      width: 18px;
    }
  }
}

.tag-div {
  padding: 3px 12px 12px 12px;

  .search-tag {
    background: #f5f6f7;
    border-radius: 2px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 17px;
    padding: 3px 13px;
    margin: 0 10px 10px 0;
    white-space: nowrap;
    display: inline-block;
  }
}
.back-btn-img {
  display: inline-block;
  padding-left: 12px;
  height: 54px;
  vertical-align: top;

  img {
    margin-top: 15px;
    height: 24px;
    width: 24px;
  }
}
.shop-goods-div{
    height: 100%;
    overflow: auto;
    background: #F5F6F7;
    padding: 0 0 120px 0;
    box-sizing: border-box;
}
.fixed-title {
  position: fixed;
  top: 0;
  padding-top: 44px;
  width: 100%;
  background-color: #ffffff;
  z-index: 10;
}
.empty-placehoder {
    padding-bottom: 1px;
    background-color: #F5F5F5;
  }
  .list-box {
    padding: 12px;
    margin: 10px 12px 0;
    display: flex;
    // border-bottom: 1px solid #f1f1f1;
    background-color: #fff;
    border-radius: 6px;

    .list-box-warpper {
      width: 100%;
      display: flex;
      // background-color: #fff;
      border-radius: 6px;
      
    }
    .list-box-left {
      margin-right: 6px;
      img {
        width: 64px;
        height: 64px;
        border-radius: 5px;
        object-fit:cover
      }
    }

    .list-box-right {
      width: calc(100% - 70px);
      .content {
        display: flex;
      }
      .left-amount {
        display: inline-block;
        padding: 2px 3px 1px;
        height: 17px;
        font-size: 12px;
        color: #F9591B;
        line-height: 17px;
        margin: 6px 0;
        background: rgba(249, 89, 27, 0.09);
        border-radius: 3px;
      }
      .right-amount{
          display: inline-block;
          padding: 2px 3px 1px;
          box-sizing: border-box;
          background: rgba(220,160,60,0.15);
            border-radius: 3px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #AE6C28;
      }
      .discounts {
          margin-top: 8px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .discount {
          position: relative;
          padding: 2px 4px 1px;
          margin: 0 6px 5px 0;
          height: 17px;
          font-size: 12px;
          color: #F9591B;
          line-height: 17px;
          border-radius: 3px;
          // border: 1px solid #F9591B;
          &::before {
            content: "";
            position: absolute;
            left: 0;
            width: 200%;
            height: 200%;
            border: 1px solid #F9591B;
            border-radius: 6px; /* 也可以设置圆角 */
            transform-origin: 0 -4px;
            transform: scale(0.5, 0.5);
            box-sizing: border-box;
          }
        }
        .foldimg{
            position: absolute;
            right: 0px;
            top:6px;
            width: 10px;
            height: 8px;
        }
      }
    }

    .left {
      flex: 1;
      padding-right: 15px;
      .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .t-left {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          font-weight: bold;
        }
        .t-right {
        //   font-size: 16px;
        //   color: #666666;
          // padding-right: 15px;
          font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
        }
      }
      .addres {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }

    }
    .right {
      width: 27px;
      height: 52px;
      border-left: 1px solid #eeeeee;
      position: relative;
      img {
        // width: 12px;
        // height: 17px;
         width: 16px;
        height: 18px;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
    }
  }
</style>